export const RETURN_MESSAGE = {
  EVERYTHING_OK: 0,
  SOMETHING_WENT_WRONG: 1,
  USER_EMAIL_ADDRESS_ALREADY_EXISTS: 2,
  FAILED_TO_CREATE_ACCOUNT_IN_IAM: 3,
  TOKEN_IS_REQUIRED: 4,
  FAILED_TO_CREATE_ACCOUNT_IN_TITAN: 5,
};
